module.exports = __webpack_public_path__ + "assets/img/2.84bd34b2.png";